// Generated from src\test\java\com\freelog\ccg\MappingRuleToken.g4 by ANTLR 4.8
// jshint ignore: start
var antlr4 = require('antlr4/index');



var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0002\"\u015b\b\u0001\b\u0001\u0004\u0002\t\u0002\u0004\u0003\t\u0003",
    "\u0004\u0004\t\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007",
    "\t\u0007\u0004\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004",
    "\f\t\f\u0004\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010",
    "\t\u0010\u0004\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013",
    "\u0004\u0014\t\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017",
    "\t\u0017\u0004\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a",
    "\u0004\u001b\t\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e",
    "\t\u001e\u0004\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#",
    "\t#\u0004$\t$\u0004%\t%\u0004&\t&\u0004\'\t\'\u0004(\t(\u0004)\t)\u0004",
    "*\t*\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0004\u0003",
    "\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003",
    "\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003",
    "\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0006\u0003",
    "\u0006\u0003\u0006\u0003\u0007\u0003\u0007\u0003\u0007\u0003\u0007\u0003",
    "\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003",
    "\b\u0003\b\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003\t\u0003",
    "\t\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\u000b\u0003\u000b\u0003",
    "\u000b\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003\f\u0003\f\u0003",
    "\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\f\u0003\r\u0003\r\u0003\r\u0003",
    "\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\r\u0003\u000e\u0003",
    "\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003",
    "\u000e\u0003\u000e\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003",
    "\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003\u000f\u0003",
    "\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003",
    "\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0010\u0003\u0011\u0003",
    "\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003",
    "\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0012\u0003",
    "\u0012\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0014\u0003\u0014\u0003",
    "\u0014\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0003\u0015\u0003",
    "\u0016\u0003\u0016\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0017\u0003",
    "\u0018\u0003\u0018\u0003\u0019\u0003\u0019\u0003\u001a\u0003\u001a\u0003",
    "\u001b\u0003\u001b\u0003\u001c\u0006\u001c\u00f7\n\u001c\r\u001c\u000e",
    "\u001c\u00f8\u0003\u001d\u0003\u001d\u0003\u001d\u0007\u001d\u00fe\n",
    "\u001d\f\u001d\u000e\u001d\u0101\u000b\u001d\u0003\u001d\u0003\u001d",
    "\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0007\u001e\u0109\n",
    "\u001e\f\u001e\u000e\u001e\u010c\u000b\u001e\u0003\u001e\u0003\u001e",
    "\u0003\u001e\u0003\u001e\u0005\u001e\u0112\n\u001e\u0003\u001e\u0005",
    "\u001e\u0115\n\u001e\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f",
    "\u0007\u001f\u011b\n\u001f\f\u001f\u000e\u001f\u011e\u000b\u001f\u0003",
    "\u001f\u0005\u001f\u0121\n\u001f\u0003\u001f\u0003\u001f\u0003 \u0006",
    " \u0126\n \r \u000e \u0127\u0003 \u0003 \u0003!\u0005!\u012d\n!\u0003",
    "!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003!\u0003\"\u0003\"\u0003",
    "\"\u0005\"\u013a\n\"\u0003#\u0003#\u0003#\u0003#\u0003#\u0003#\u0003",
    "$\u0005$\u0143\n$\u0003$\u0003$\u0005$\u0147\n$\u0003%\u0003%\u0005",
    "%\u014b\n%\u0003&\u0003&\u0007&\u014f\n&\f&\u000e&\u0152\u000b&\u0003",
    "\'\u0003\'\u0003(\u0003(\u0003)\u0003)\u0003*\u0003*\u0004\u010a\u011c",
    "\u0002+\u0004\u0003\u0006\u0004\b\u0005\n\u0006\f\u0007\u000e\b\u0010",
    "\t\u0012\n\u0014\u000b\u0016\f\u0018\r\u001a\u000e\u001c\u000f\u001e",
    "\u0010 \u0011\"\u0012$\u0013&\u0014(\u0015*\u0016,\u0017.\u00180\u0019",
    "2\u001a4\u001b6\u001c8\u001d:\u001e<\u001f> @!B\"D\u0002F\u0002H\u0002",
    "J\u0002L\u0002N\u0002P\u0002R\u0002T\u0002\u0004\u0002\u0003\u000b\n",
    "\u0002\u000b\f\u000f\u000f\"\"$&11@@BB~~\u0004\u0002$$^^\u0005\u0002",
    "\u000b\f\u000f\u000f\"\"\u0004\u0002``\u0080\u0080\n\u0002$$11^^ddh",
    "hppttvv\u0003\u00023;\u0003\u00022;\u0005\u00022;CHch\u0004\u0002C\\",
    "c|\u0002\u015f\u0002\u0004\u0003\u0002\u0002\u0002\u0002\u0006\u0003",
    "\u0002\u0002\u0002\u0002\b\u0003\u0002\u0002\u0002\u0002\n\u0003\u0002",
    "\u0002\u0002\u0002\f\u0003\u0002\u0002\u0002\u0002\u000e\u0003\u0002",
    "\u0002\u0002\u0002\u0010\u0003\u0002\u0002\u0002\u0002\u0012\u0003\u0002",
    "\u0002\u0002\u0002\u0014\u0003\u0002\u0002\u0002\u0002\u0016\u0003\u0002",
    "\u0002\u0002\u0002\u0018\u0003\u0002\u0002\u0002\u0002\u001a\u0003\u0002",
    "\u0002\u0002\u0002\u001c\u0003\u0002\u0002\u0002\u0002\u001e\u0003\u0002",
    "\u0002\u0002\u0002 \u0003\u0002\u0002\u0002\u0002\"\u0003\u0002\u0002",
    "\u0002\u0002$\u0003\u0002\u0002\u0002\u0002&\u0003\u0002\u0002\u0002",
    "\u0002(\u0003\u0002\u0002\u0002\u0002*\u0003\u0002\u0002\u0002\u0002",
    ",\u0003\u0002\u0002\u0002\u0002.\u0003\u0002\u0002\u0002\u00020\u0003",
    "\u0002\u0002\u0002\u00022\u0003\u0002\u0002\u0002\u00024\u0003\u0002",
    "\u0002\u0002\u00026\u0003\u0002\u0002\u0002\u00028\u0003\u0002\u0002",
    "\u0002\u0002:\u0003\u0002\u0002\u0002\u0002<\u0003\u0002\u0002\u0002",
    "\u0002>\u0003\u0002\u0002\u0002\u0002@\u0003\u0002\u0002\u0002\u0003",
    "B\u0003\u0002\u0002\u0002\u0004V\u0003\u0002\u0002\u0002\u0006Z\u0003",
    "\u0002\u0002\u0002\b`\u0003\u0002\u0002\u0002\no\u0003\u0002\u0002\u0002",
    "\fr\u0003\u0002\u0002\u0002\u000eu\u0003\u0002\u0002\u0002\u0010y\u0003",
    "\u0002\u0002\u0002\u0012\u0084\u0003\u0002\u0002\u0002\u0014\u008c\u0003",
    "\u0002\u0002\u0002\u0016\u0091\u0003\u0002\u0002\u0002\u0018\u0096\u0003",
    "\u0002\u0002\u0002\u001a\u00a0\u0003\u0002\u0002\u0002\u001c\u00aa\u0003",
    "\u0002\u0002\u0002\u001e\u00b3\u0003\u0002\u0002\u0002 \u00bf\u0003",
    "\u0002\u0002\u0002\"\u00c8\u0003\u0002\u0002\u0002$\u00d4\u0003\u0002",
    "\u0002\u0002&\u00d9\u0003\u0002\u0002\u0002(\u00df\u0003\u0002\u0002",
    "\u0002*\u00e2\u0003\u0002\u0002\u0002,\u00e7\u0003\u0002\u0002\u0002",
    ".\u00e9\u0003\u0002\u0002\u00020\u00ed\u0003\u0002\u0002\u00022\u00ef",
    "\u0003\u0002\u0002\u00024\u00f1\u0003\u0002\u0002\u00026\u00f3\u0003",
    "\u0002\u0002\u00028\u00f6\u0003\u0002\u0002\u0002:\u00fa\u0003\u0002",
    "\u0002\u0002<\u0104\u0003\u0002\u0002\u0002>\u0116\u0003\u0002\u0002",
    "\u0002@\u0125\u0003\u0002\u0002\u0002B\u012c\u0003\u0002\u0002\u0002",
    "D\u0136\u0003\u0002\u0002\u0002F\u013b\u0003\u0002\u0002\u0002H\u0146",
    "\u0003\u0002\u0002\u0002J\u014a\u0003\u0002\u0002\u0002L\u014c\u0003",
    "\u0002\u0002\u0002N\u0153\u0003\u0002\u0002\u0002P\u0155\u0003\u0002",
    "\u0002\u0002R\u0157\u0003\u0002\u0002\u0002T\u0159\u0003\u0002\u0002",
    "\u0002VW\u0007c\u0002\u0002WX\u0007f\u0002\u0002XY\u0007f\u0002\u0002",
    "Y\u0005\u0003\u0002\u0002\u0002Z[\u0007c\u0002\u0002[\\\u0007n\u0002",
    "\u0002\\]\u0007v\u0002\u0002]^\u0007g\u0002\u0002^_\u0007t\u0002\u0002",
    "_\u0007\u0003\u0002\u0002\u0002`a\u0007c\u0002\u0002ab\u0007e\u0002",
    "\u0002bc\u0007v\u0002\u0002cd\u0007k\u0002\u0002de\u0007x\u0002\u0002",
    "ef\u0007c\u0002\u0002fg\u0007v\u0002\u0002gh\u0007g\u0002\u0002hi\u0007",
    "a\u0002\u0002ij\u0007v\u0002\u0002jk\u0007j\u0002\u0002kl\u0007g\u0002",
    "\u0002lm\u0007o\u0002\u0002mn\u0007g\u0002\u0002n\t\u0003\u0002\u0002",
    "\u0002op\u0007c\u0002\u0002pq\u0007u\u0002\u0002q\u000b\u0003\u0002",
    "\u0002\u0002rs\u0007f\u0002\u0002st\u0007q\u0002\u0002t\r\u0003\u0002",
    "\u0002\u0002uv\u0007g\u0002\u0002vw\u0007p\u0002\u0002wx\u0007f\u0002",
    "\u0002x\u000f\u0003\u0002\u0002\u0002yz\u0007u\u0002\u0002z{\u0007g",
    "\u0002\u0002{|\u0007v\u0002\u0002|}\u0007a\u0002\u0002}~\u0007n\u0002",
    "\u0002~\u007f\u0007c\u0002\u0002\u007f\u0080\u0007d\u0002\u0002\u0080",
    "\u0081\u0007g\u0002\u0002\u0081\u0082\u0007n\u0002\u0002\u0082\u0083",
    "\u0007u\u0002\u0002\u0083\u0011\u0003\u0002\u0002\u0002\u0084\u0085",
    "\u0007t\u0002\u0002\u0085\u0086\u0007g\u0002\u0002\u0086\u0087\u0007",
    "r\u0002\u0002\u0087\u0088\u0007n\u0002\u0002\u0088\u0089\u0007c\u0002",
    "\u0002\u0089\u008a\u0007e\u0002\u0002\u008a\u008b\u0007g\u0002\u0002",
    "\u008b\u0013\u0003\u0002\u0002\u0002\u008c\u008d\u0007u\u0002\u0002",
    "\u008d\u008e\u0007j\u0002\u0002\u008e\u008f\u0007q\u0002\u0002\u008f",
    "\u0090\u0007y\u0002\u0002\u0090\u0015\u0003\u0002\u0002\u0002\u0091",
    "\u0092\u0007j\u0002\u0002\u0092\u0093\u0007k\u0002\u0002\u0093\u0094",
    "\u0007f\u0002\u0002\u0094\u0095\u0007g\u0002\u0002\u0095\u0017\u0003",
    "\u0002\u0002\u0002\u0096\u0097\u0007u\u0002\u0002\u0097\u0098\u0007",
    "g\u0002\u0002\u0098\u0099\u0007v\u0002\u0002\u0099\u009a\u0007a\u0002",
    "\u0002\u009a\u009b\u0007v\u0002\u0002\u009b\u009c\u0007k\u0002\u0002",
    "\u009c\u009d\u0007v\u0002\u0002\u009d\u009e\u0007n\u0002\u0002\u009e",
    "\u009f\u0007g\u0002\u0002\u009f\u0019\u0003\u0002\u0002\u0002\u00a0",
    "\u00a1\u0007u\u0002\u0002\u00a1\u00a2\u0007g\u0002\u0002\u00a2\u00a3",
    "\u0007v\u0002\u0002\u00a3\u00a4\u0007a\u0002\u0002\u00a4\u00a5\u0007",
    "e\u0002\u0002\u00a5\u00a6\u0007q\u0002\u0002\u00a6\u00a7\u0007x\u0002",
    "\u0002\u00a7\u00a8\u0007g\u0002\u0002\u00a8\u00a9\u0007t\u0002\u0002",
    "\u00a9\u001b\u0003\u0002\u0002\u0002\u00aa\u00ab\u0007c\u0002\u0002",
    "\u00ab\u00ac\u0007f\u0002\u0002\u00ac\u00ad\u0007f\u0002\u0002\u00ad",
    "\u00ae\u0007a\u0002\u0002\u00ae\u00af\u0007c\u0002\u0002\u00af\u00b0",
    "\u0007v\u0002\u0002\u00b0\u00b1\u0007v\u0002\u0002\u00b1\u00b2\u0007",
    "t\u0002\u0002\u00b2\u001d\u0003\u0002\u0002\u0002\u00b3\u00b4\u0007",
    "f\u0002\u0002\u00b4\u00b5\u0007g\u0002\u0002\u00b5\u00b6\u0007n\u0002",
    "\u0002\u00b6\u00b7\u0007g\u0002\u0002\u00b7\u00b8\u0007v\u0002\u0002",
    "\u00b8\u00b9\u0007g\u0002\u0002\u00b9\u00ba\u0007a\u0002\u0002\u00ba",
    "\u00bb\u0007c\u0002\u0002\u00bb\u00bc\u0007v\u0002\u0002\u00bc\u00bd",
    "\u0007v\u0002\u0002\u00bd\u00be\u0007t\u0002\u0002\u00be\u001f\u0003",
    "\u0002\u0002\u0002\u00bf\u00c0\u0007c\u0002\u0002\u00c0\u00c1\u0007",
    "f\u0002\u0002\u00c1\u00c2\u0007f\u0002\u0002\u00c2\u00c3\u0007a\u0002",
    "\u0002\u00c3\u00c4\u0007t\u0002\u0002\u00c4\u00c5\u0007g\u0002\u0002",
    "\u00c5\u00c6\u0007n\u0002\u0002\u00c6\u00c7\u0007{\u0002\u0002\u00c7",
    "!\u0003\u0002\u0002\u0002\u00c8\u00c9\u0007f\u0002\u0002\u00c9\u00ca",
    "\u0007g\u0002\u0002\u00ca\u00cb\u0007n\u0002\u0002\u00cb\u00cc\u0007",
    "g\u0002\u0002\u00cc\u00cd\u0007v\u0002\u0002\u00cd\u00ce\u0007g\u0002",
    "\u0002\u00ce\u00cf\u0007a\u0002\u0002\u00cf\u00d0\u0007t\u0002\u0002",
    "\u00d0\u00d1\u0007g\u0002\u0002\u00d1\u00d2\u0007n\u0002\u0002\u00d2",
    "\u00d3\u0007{\u0002\u0002\u00d3#\u0003\u0002\u0002\u0002\u00d4\u00d5",
    "\u0007y\u0002\u0002\u00d5\u00d6\u0007k\u0002\u0002\u00d6\u00d7\u0007",
    "v\u0002\u0002\u00d7\u00d8\u0007j\u0002\u0002\u00d8%\u0003\u0002\u0002",
    "\u0002\u00d9\u00da\u0007w\u0002\u0002\u00da\u00db\u0007p\u0002\u0002",
    "\u00db\u00dc\u0007f\u0002\u0002\u00dc\u00dd\u0007g\u0002\u0002\u00dd",
    "\u00de\u0007t\u0002\u0002\u00de\'\u0003\u0002\u0002\u0002\u00df\u00e0",
    "\u0007v\u0002\u0002\u00e0\u00e1\u0007q\u0002\u0002\u00e1)\u0003\u0002",
    "\u0002\u0002\u00e2\u00e3\u0007h\u0002\u0002\u00e3\u00e4\u0007t\u0002",
    "\u0002\u00e4\u00e5\u0007q\u0002\u0002\u00e5\u00e6\u0007o\u0002\u0002",
    "\u00e6+\u0003\u0002\u0002\u0002\u00e7\u00e8\u0007&\u0002\u0002\u00e8",
    "-\u0003\u0002\u0002\u0002\u00e9\u00ea\u0007B\u0002\u0002\u00ea\u00eb",
    "\u0003\u0002\u0002\u0002\u00eb\u00ec\b\u0017\u0002\u0002\u00ec/\u0003",
    "\u0002\u0002\u0002\u00ed\u00ee\u0007%\u0002\u0002\u00ee1\u0003\u0002",
    "\u0002\u0002\u00ef\u00f0\u00071\u0002\u0002\u00f03\u0003\u0002\u0002",
    "\u0002\u00f1\u00f2\u0007@\u0002\u0002\u00f25\u0003\u0002\u0002\u0002",
    "\u00f3\u00f4\u0007~\u0002\u0002\u00f47\u0003\u0002\u0002\u0002\u00f5",
    "\u00f7\n\u0002\u0002\u0002\u00f6\u00f5\u0003\u0002\u0002\u0002\u00f7",
    "\u00f8\u0003\u0002\u0002\u0002\u00f8\u00f6\u0003\u0002\u0002\u0002\u00f8",
    "\u00f9\u0003\u0002\u0002\u0002\u00f99\u0003\u0002\u0002\u0002\u00fa",
    "\u00ff\u0007$\u0002\u0002\u00fb\u00fe\u0005D\"\u0002\u00fc\u00fe\n\u0003",
    "\u0002\u0002\u00fd\u00fb\u0003\u0002\u0002\u0002\u00fd\u00fc\u0003\u0002",
    "\u0002\u0002\u00fe\u0101\u0003\u0002\u0002\u0002\u00ff\u00fd\u0003\u0002",
    "\u0002\u0002\u00ff\u0100\u0003\u0002\u0002\u0002\u0100\u0102\u0003\u0002",
    "\u0002\u0002\u0101\u00ff\u0003\u0002\u0002\u0002\u0102\u0103\u0007$",
    "\u0002\u0002\u0103;\u0003\u0002\u0002\u0002\u0104\u0105\u00071\u0002",
    "\u0002\u0105\u0106\u0007,\u0002\u0002\u0106\u010a\u0003\u0002\u0002",
    "\u0002\u0107\u0109\u000b\u0002\u0002\u0002\u0108\u0107\u0003\u0002\u0002",
    "\u0002\u0109\u010c\u0003\u0002\u0002\u0002\u010a\u010b\u0003\u0002\u0002",
    "\u0002\u010a\u0108\u0003\u0002\u0002\u0002\u010b\u010d\u0003\u0002\u0002",
    "\u0002\u010c\u010a\u0003\u0002\u0002\u0002\u010d\u010e\u0007,\u0002",
    "\u0002\u010e\u010f\u00071\u0002\u0002\u010f\u0114\u0003\u0002\u0002",
    "\u0002\u0110\u0112\u0007\u000f\u0002\u0002\u0111\u0110\u0003\u0002\u0002",
    "\u0002\u0111\u0112\u0003\u0002\u0002\u0002\u0112\u0113\u0003\u0002\u0002",
    "\u0002\u0113\u0115\u0007\f\u0002\u0002\u0114\u0111\u0003\u0002\u0002",
    "\u0002\u0114\u0115\u0003\u0002\u0002\u0002\u0115=\u0003\u0002\u0002",
    "\u0002\u0116\u0117\u00071\u0002\u0002\u0117\u0118\u00071\u0002\u0002",
    "\u0118\u011c\u0003\u0002\u0002\u0002\u0119\u011b\u000b\u0002\u0002\u0002",
    "\u011a\u0119\u0003\u0002\u0002\u0002\u011b\u011e\u0003\u0002\u0002\u0002",
    "\u011c\u011d\u0003\u0002\u0002\u0002\u011c\u011a\u0003\u0002\u0002\u0002",
    "\u011d\u0120\u0003\u0002\u0002\u0002\u011e\u011c\u0003\u0002\u0002\u0002",
    "\u011f\u0121\u0007\u000f\u0002\u0002\u0120\u011f\u0003\u0002\u0002\u0002",
    "\u0120\u0121\u0003\u0002\u0002\u0002\u0121\u0122\u0003\u0002\u0002\u0002",
    "\u0122\u0123\u0007\f\u0002\u0002\u0123?\u0003\u0002\u0002\u0002\u0124",
    "\u0126\t\u0004\u0002\u0002\u0125\u0124\u0003\u0002\u0002\u0002\u0126",
    "\u0127\u0003\u0002\u0002\u0002\u0127\u0125\u0003\u0002\u0002\u0002\u0127",
    "\u0128\u0003\u0002\u0002\u0002\u0128\u0129\u0003\u0002\u0002\u0002\u0129",
    "\u012a\b \u0003\u0002\u012aA\u0003\u0002\u0002\u0002\u012b\u012d\t\u0005",
    "\u0002\u0002\u012c\u012b\u0003\u0002\u0002\u0002\u012c\u012d\u0003\u0002",
    "\u0002\u0002\u012d\u012e\u0003\u0002\u0002\u0002\u012e\u012f\u0005J",
    "%\u0002\u012f\u0130\u00070\u0002\u0002\u0130\u0131\u0005J%\u0002\u0131",
    "\u0132\u00070\u0002\u0002\u0132\u0133\u0005J%\u0002\u0133\u0134\u0003",
    "\u0002\u0002\u0002\u0134\u0135\b!\u0004\u0002\u0135C\u0003\u0002\u0002",
    "\u0002\u0136\u0139\u0007^\u0002\u0002\u0137\u013a\t\u0006\u0002\u0002",
    "\u0138\u013a\u0005F#\u0002\u0139\u0137\u0003\u0002\u0002\u0002\u0139",
    "\u0138\u0003\u0002\u0002\u0002\u013aE\u0003\u0002\u0002\u0002\u013b",
    "\u013c\u0007w\u0002\u0002\u013c\u013d\u0005P(\u0002\u013d\u013e\u0005",
    "P(\u0002\u013e\u013f\u0005P(\u0002\u013f\u0140\u0005P(\u0002\u0140G",
    "\u0003\u0002\u0002\u0002\u0141\u0143\u0007/\u0002\u0002\u0142\u0141",
    "\u0003\u0002\u0002\u0002\u0142\u0143\u0003\u0002\u0002\u0002\u0143\u0144",
    "\u0003\u0002\u0002\u0002\u0144\u0147\u0005L&\u0002\u0145\u0147\u0007",
    "2\u0002\u0002\u0146\u0142\u0003\u0002\u0002\u0002\u0146\u0145\u0003",
    "\u0002\u0002\u0002\u0147I\u0003\u0002\u0002\u0002\u0148\u014b\u0005",
    "L&\u0002\u0149\u014b\u00072\u0002\u0002\u014a\u0148\u0003\u0002\u0002",
    "\u0002\u014a\u0149\u0003\u0002\u0002\u0002\u014bK\u0003\u0002\u0002",
    "\u0002\u014c\u0150\t\u0007\u0002\u0002\u014d\u014f\t\b\u0002\u0002\u014e",
    "\u014d\u0003\u0002\u0002\u0002\u014f\u0152\u0003\u0002\u0002\u0002\u0150",
    "\u014e\u0003\u0002\u0002\u0002\u0150\u0151\u0003\u0002\u0002\u0002\u0151",
    "M\u0003\u0002\u0002\u0002\u0152\u0150\u0003\u0002\u0002\u0002\u0153",
    "\u0154\t\b\u0002\u0002\u0154O\u0003\u0002\u0002\u0002\u0155\u0156\t",
    "\t\u0002\u0002\u0156Q\u0003\u0002\u0002\u0002\u0157\u0158\t\n\u0002",
    "\u0002\u0158S\u0003\u0002\u0002\u0002\u0159\u015a\u0004\u4e02\u9ff1",
    "\u0002\u015aU\u0003\u0002\u0002\u0002\u0013\u0002\u0003\u00f8\u00fd",
    "\u00ff\u010a\u0111\u0114\u011c\u0120\u0127\u012c\u0139\u0142\u0146\u014a",
    "\u0150\u0005\u0004\u0003\u0002\b\u0002\u0002\u0004\u0002\u0002"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

function MappingRuleToken(input) {
	antlr4.Lexer.call(this, input);
    this._interp = new antlr4.atn.LexerATNSimulator(this, atn, decisionsToDFA, new antlr4.PredictionContextCache());
    return this;
}

MappingRuleToken.prototype = Object.create(antlr4.Lexer.prototype);
MappingRuleToken.prototype.constructor = MappingRuleToken;

Object.defineProperty(MappingRuleToken.prototype, "atn", {
        get : function() {
                return atn;
        }
});

MappingRuleToken.EOF = antlr4.Token.EOF;
MappingRuleToken.ADD = 1;
MappingRuleToken.ALTER = 2;
MappingRuleToken.ACTIVATE_THEME = 3;
MappingRuleToken.AS = 4;
MappingRuleToken.DO = 5;
MappingRuleToken.END = 6;
MappingRuleToken.SET_LABELS = 7;
MappingRuleToken.REPLACE = 8;
MappingRuleToken.SHOW = 9;
MappingRuleToken.HIDE = 10;
MappingRuleToken.SET_TITLE = 11;
MappingRuleToken.SET_COVER = 12;
MappingRuleToken.ADD_ATTR = 13;
MappingRuleToken.DELETE_ATTR = 14;
MappingRuleToken.ADD_RELY = 15;
MappingRuleToken.DELETE_RELY = 16;
MappingRuleToken.WITH = 17;
MappingRuleToken.UNDER = 18;
MappingRuleToken.TO = 19;
MappingRuleToken.FROM = 20;
MappingRuleToken.DOLLAR = 21;
MappingRuleToken.AT = 22;
MappingRuleToken.HASH = 23;
MappingRuleToken.SLASH = 24;
MappingRuleToken.GT = 25;
MappingRuleToken.SEPARATOR = 26;
MappingRuleToken.ID = 27;
MappingRuleToken.STRING = 28;
MappingRuleToken.COMMENT = 29;
MappingRuleToken.COMMENT_LINE = 30;
MappingRuleToken.WS = 31;
MappingRuleToken.SEMVER = 32;

MappingRuleToken.SEMVER_MODE = 1;

MappingRuleToken.prototype.channelNames = [ "DEFAULT_TOKEN_CHANNEL", "HIDDEN" ];

MappingRuleToken.prototype.modeNames = [ "DEFAULT_MODE", "SEMVER_MODE" ];

MappingRuleToken.prototype.literalNames = [ null, "'add'", "'alter'", "'activate_theme'", 
                                            "'as'", "'do'", "'end'", "'set_labels'", 
                                            "'replace'", "'show'", "'hide'", 
                                            "'set_title'", "'set_cover'", 
                                            "'add_attr'", "'delete_attr'", 
                                            "'add_rely'", "'delete_rely'", 
                                            "'with'", "'under'", "'to'", 
                                            "'from'", "'$'", "'@'", "'#'", 
                                            "'/'", "'>'", "'|'" ];

MappingRuleToken.prototype.symbolicNames = [ null, "ADD", "ALTER", "ACTIVATE_THEME", 
                                             "AS", "DO", "END", "SET_LABELS", 
                                             "REPLACE", "SHOW", "HIDE", 
                                             "SET_TITLE", "SET_COVER", "ADD_ATTR", 
                                             "DELETE_ATTR", "ADD_RELY", 
                                             "DELETE_RELY", "WITH", "UNDER", 
                                             "TO", "FROM", "DOLLAR", "AT", 
                                             "HASH", "SLASH", "GT", "SEPARATOR", 
                                             "ID", "STRING", "COMMENT", 
                                             "COMMENT_LINE", "WS", "SEMVER" ];

MappingRuleToken.prototype.ruleNames = [ "ADD", "ALTER", "ACTIVATE_THEME", 
                                         "AS", "DO", "END", "SET_LABELS", 
                                         "REPLACE", "SHOW", "HIDE", "SET_TITLE", 
                                         "SET_COVER", "ADD_ATTR", "DELETE_ATTR", 
                                         "ADD_RELY", "DELETE_RELY", "WITH", 
                                         "UNDER", "TO", "FROM", "DOLLAR", 
                                         "AT", "HASH", "SLASH", "GT", "SEPARATOR", 
                                         "ID", "STRING", "COMMENT", "COMMENT_LINE", 
                                         "WS", "SEMVER", "ESC", "UNICODE", 
                                         "INT", "NATURAL_INT", "POSITIVE_INT", 
                                         "DIGIT", "HEX", "ALPHABET", "CHINESE_WORD" ];

MappingRuleToken.prototype.grammarFileName = "MappingRuleToken.g4";


exports.MappingRuleToken = MappingRuleToken;

